<template>
  <input
      class="AppInput"
      :class="{ [`has-status-${status}`]: status }"
      @input="$emit('input', $event.target.value)" :placeholder="placeholder" >
</template>

<script>
export default {
  name: 'AppInput',
  props: {
    status: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },
};
</script>

<style>
.AppInput {
  border: 1px solid rgb(205, 205, 205); border-radius: 4px; width: 100%; height: 33px; padding: 7px;
  font-family: RTA;
}
.AppInput-has-status-error {
  border-color: red;
}

</style>